import React from 'react';

import styles from './DefaultContainer.module.scss';

const DefaultContainer = ({children}) => {

  return (
    <div className={styles.container}>{children}</div>
  )
}

export default DefaultContainer;